import React, { Component } from 'react'
import {StyleSheet, View, Platform} from 'react-native'
import { JDText, JDTouchable, JDDevice, JDImage } from '@jdreact/jdreact-core-lib'

import PropTypes from "prop-types"
import arrowDownImg from '../../../images/detail/arrow-down.png'
import arrowUpImg from '../../../images/detail/arrow-up.png'

const propTypes = {
	introduction: PropTypes.string,
	cityId: PropTypes.number
};
export default class HouseDesItem extends Component {
	static contextTypes = {
		router: PropTypes.object
	};
	constructor() {
		super();
		this.state = {
			numLines: null,
			isMoreThan: false, // 所传的文字是否超过三行
			isMore: false,
			maxHeight: null
		}
	}
	render() {
		let {introduction, cityId} = this.props;
		return (
			<View style={desStyles.desBox}>
				<JDText
					style={desStyles.detailContent}
					numberOfLines={this.state.isMore ? null : this.state.numLines}
					onLayout={(event)=>{
						let height = event.nativeEvent.layout.height;
						if(this.state.maxHeight === null){
							this.setState({
								maxHeight: height,
								numLines: 3
							});
						} else {
							if(this.state.maxHeight > height){
								this.setState({
									isMoreThan: true
								});
							}
						}
					}}
				>{introduction}</JDText>
				<View>
					{
						this.state.isMore &&
						<JDTouchable onPress={() => {
							this.setState({isMore: !this.state.isMore})
						}}>
							<View style={desStyles.btnWrapper}>
								<JDText style={desStyles.btn}>收起</JDText>
								<JDImage source={arrowUpImg} style={desStyles.arrow}></JDImage>
							</View>
						</JDTouchable>
					}
					{
						!this.state.isMore && this.state.isMoreThan &&
						<JDTouchable onPress={() => {
							this.setState({isMore: !this.state.isMore})
						}}>
							<View style={desStyles.btnWrapper}>
								<JDText style={desStyles.btn}>展开</JDText>
								<JDImage source={arrowDownImg} style={desStyles.arrow}></JDImage>
							</View>
						</JDTouchable>
					}
				</View>
			</View>
		)
	}
}
const desStyles = StyleSheet.create({
	desBox: {

	},
	detailContent: {
		width: '100%',
		lineHeight: JDDevice.getRpx(42),
		color: '#1a1a1a',
		fontSize: JDDevice.getFontSize(28),
		justifyContent: 'space-between',
		marginBottom: JDDevice.getRpx(20),
	},
	btn: {
		color: '#555555',
		fontSize: JDDevice.getFontSize(24),
		textAlign: 'right',
		fontFamily: "PingFang SC",
		fontWeight: 'normal',
		lineHeight: JDDevice.getRpx(40)
	},
	companyDes: {
		marginBottom: JDDevice.getRpx(40),
		color: '#848689',
		textAlign: 'right',
		fontSize: JDDevice.getFontSize(28)
	},
	btnWrapper:{
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-end',
		marginBottom: JDDevice.getRpx(28),
	},
	arrow:{
		width: JDDevice.getRpx(40),
		height: JDDevice.getRpx(40),
	}
});
